import { render, staticRenderFns } from "./notification-ProjectAssigned.vue?vue&type=template&id=0b6a0cb4&scoped=true"
import script from "./notification-ProjectAssigned.vue?vue&type=script&lang=js"
export * from "./notification-ProjectAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6a0cb4",
  null
  
)

export default component.exports